export var HeadingSizeType;
(function (HeadingSizeType) {
    HeadingSizeType["TITLE12"] = "title12";
    HeadingSizeType["TITLE14"] = "title14";
    HeadingSizeType["TITLE16"] = "title16";
    HeadingSizeType["TITLE18"] = "title18";
    HeadingSizeType["TITLE20"] = "title20";
    HeadingSizeType["TITLE24"] = "title24";
    HeadingSizeType["TITLE28"] = "title28";
    HeadingSizeType["TITLE36"] = "title36";
    HeadingSizeType["TITLE48"] = "title48";
    HeadingSizeType["TITLE60"] = "title60";
    HeadingSizeType["TITLE72"] = "title72";
})(HeadingSizeType || (HeadingSizeType = {}));
export var HeadingAlign;
(function (HeadingAlign) {
    HeadingAlign["LEFT"] = "left";
    HeadingAlign["CENTER"] = "center";
    HeadingAlign["RIGHT"] = "right";
    HeadingAlign["JUSTIFY"] = "justify";
})(HeadingAlign || (HeadingAlign = {}));
//# sourceMappingURL=Heading.enum.js.map